// extracted by mini-css-extract-plugin
module.exports = {"container":"ExchangeRateChart_container__27gTK","changePriceBox":"ExchangeRateChart_changePriceBox__RJmeW"};